// vendor
import _orderBy from 'lodash/orderBy'
// constants
import { COMPONENTS_TYPE_MAP, WIDGETS_WITH_OPTIONS } from '../constants.js';

function buildAnsId (answer) {
  return {
    key: answer.question_sub ? 'question_sub' : 'question',
    value: answer.question_sub ? answer.question_sub : answer.question
  };
}

const passExistingAnswer = (questionProps, questionType, vm) => {
// вот такая проверка. А куда деваться. Тут id, там не id
  let result = null;
  if (questionType === 'textgroup') {
    questionProps.options = questionProps.options.map((item) => {
      item.question_sub = item.id || item.question_sub;
      delete item.id;
      return item;
    });
    questionProps.filled = [];
    questionProps.options.map((option) => {
      result = vm.$store.getters['answers/getAnswer'](buildAnsId(option));
      if (result) questionProps.filled.push(result);
    });
  }

  let answer = vm.$store.getters['answers/getAnswer'](buildAnsId(questionProps));

  if (WIDGETS_WITH_OPTIONS.includes(questionType)) {
    questionProps.options = _orderBy(questionProps.options, 'sort');
    if (answer && answer.options) {
      questionProps.selectedOpts = answer.options;
    }
  }

  if (questionType === 'radiogroup' || questionType === 'multiple_checkbox') {
    questionProps.options.map((item) => {
      item.name = questionProps.name
    })
  }

  if (questionType === 'multiple_dropdown') {
    questionProps.isMultiple = true;
  }

  if (questionType === 'checkbox') {
    if (answer && answer.checked === true) {
      questionProps.stateChecked = answer.checked;
    }
  }

  if (questionType === 'text' && answer) {
    questionProps.text = answer.num ? answer.num : answer.text;
  }

  if (questionType === 'file') {
    if (answer && answer.options) {
      questionProps.uploaded = answer.options;
    }
  }

  if (questionType === 'multiple_text' && answer) {
      questionProps.data = answer.text_multiple;
      questionProps.count = answer.text_multiple.length;
  }

  return questionProps;
};

export default {
  methods: {
    buildControls: function () {
      if (!this.pageData.elements) {
        return false;
      }

      const fieldsOrder = _orderBy(this.pageData.elements, 'sort');
      let buildResult = [];
      for (let i = 0; i < fieldsOrder.length; i++) {
        let el = fieldsOrder[i];
        const pollId = this.pageData.id;
        const type = el.input_type.name;
        const vueName = COMPONENTS_TYPE_MAP[type];
        if (!vueName) {
          // throw new Error(`cant resolve Vue component name by given component type: ${type}, id: ${el.id}, poll: ${pollId}`);
          console.error(`cant resolve Vue component name by given component type: ${type}, id: ${el.id}, poll: ${pollId}`);
          continue;
        }

        if (!this.importedTypes.includes(type) && vueName) {
          this.importedTypes.push(type);
          this.importedComponents[vueName] = () => import(`@/components/UI/${vueName}/${vueName}.vue`)
        }

        let props = {
          vueName: vueName,
          pollId: pollId,
          question: el.id,
          placeholder: el.placeholder,
          name: el.name,
          label: el.label,
          required: el.required,
          type: el.type,
          value: el.value,
          dependent: el.dependent ? el.dependent : null,
          output_type: el.insert_type ? el.insert_type.name : null // TODO: Никите - для всех добавить это поле, нет для html
        };

        if (type === 'text' && el.type === 'tel') {
          props.prepend = 'tel';
        }

        if (type === 'file') {
          if (el.mime_type) {
            props.mimeType = el.mime_type.map((item) => {
              return item.mime_type;
            });
          }
          props.totalSizeLimit = el.max_size;
        }

        const combinedProps = Object.assign(props, el);
        props = Object.assign(combinedProps, passExistingAnswer(combinedProps, type, this));
        buildResult.push(props);
      }
      this.formElements = this.combineFormRows(buildResult);
    }
  },
  data () {
    return {
      formElements: [],
      importedTypes: [],
      importedComponents: {},
      hasRowColumns: false
    }
  }
};
